import { useKeycloak } from '@lib/keycloak'
import { LoadingScreen } from '@shared/components/LoadingScreen'
import { Outlet } from 'react-router-dom'

/**
 * ProtectedRoute component
 *
 * Wrapper component that checks authentication before rendering child routes.
 * Displays a loading screen while authentication status is being determined.
 * Uses Keycloak context for authentication state.
 */
export const ProtectedRoute = () => {
  const { initialized, authenticated } = useKeycloak()

  if (!initialized) {
    return <LoadingScreen />
  }

  if (!authenticated) {
    // Keycloak will handle redirect to login via onLoad: 'login-required'
    return null
  }

  // Render child routes
  return <Outlet />
}
